<template>
  <div>
    <v-row style="margin-top: -65px;">
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="indigo">
              <v-btn icon dark @click="close">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Route Details</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <!-- <v-btn dark text @click="save()">Add</v-btn> -->
              </v-toolbar-items>
            </v-toolbar>

            <v-snackbar
              v-model="snackbar"
              top
              elevation="24"
              style="margin-top: 65px;"
            >
              Selected documents have been attached!

              <template v-slot:action="{ attrs }">
                <v-btn
                  color="indigo lighten-2"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
                  fab
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
            </v-snackbar>

            <v-card-text>
              <v-container style="margin-top: 100px;">
                <v-row>
                  <v-col cols="12" align="center" justify="center">
                    <v-btn-toggle
                      v-model="text"
                      tile
                      color="deep-purple accent-3"
                      group
                      class="text-center"
                      rounded
                      mandatory
                    >
                      <v-btn value="Details" @click="toggleButton()">
                        Details
                      </v-btn>
                      <v-divider 
                        vertical
                      ></v-divider>
                      <v-btn value="Receivers" @click="toggleButton()">
                        Receivers
                      </v-btn>
                      <v-divider
                        vertical
                      ></v-divider>
                      <v-btn value="Documents" @click="toggleButton()">
                        Documents
                      </v-btn>
                      <v-divider
                        vertical
                      ></v-divider>
                      <v-btn value="Review" @click="toggleButton()">
                        Review
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                </v-row>
              </v-container>
              <v-container v-if="text === 'Details'">
                <v-row>
                  <v-col offset="1" cols="10">
                    <v-row>
                      <v-col cols="12" class="text-center">
                        <h2>Route Details</h2>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="subject"
                          label="Route Subject"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-select
                          v-model="urgency"
                          :items="security_level_items"
                          label="Urgency Level"
                        ></v-select>
                      </v-col>
                      <v-col cols="6" class="d-flex">
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          :return-value.sync="datetime_due"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template
                            v-slot:activator="{
                              on,
                              attrs,
                            }"
                          >
                            <v-text-field
                              :value="datetime_due"
                              v-model="computedDateTimeDue"
                              label="Pick due date"
                              prepend-icon="mdi-calendar"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!dateSwitch"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="datetime_due"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menu = false">
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu.save(datetime_due)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <div>
                          <v-tooltip top>
                            <template
                              v-slot:activator="{
                                on,
                                attrs,
                              }"
                            >
                              <div v-bind="attrs" v-on="on">
                                <v-switch v-model="dateSwitch"></v-switch>
                              </div>
                            </template>
                            <span>
                              {{
                                dateSwitch
                                  ? "Disable due date"
                                  : "Enable due date"
                              }}
                            </span>
                          </v-tooltip>
                        </div>
                      </v-col>

                      <v-col cols="12">
                        <v-switch
                          v-model="uploadDocumentSwitch"
                          
                        >
                        <template v-slot:label>
                          <span>
                            <span v-show="uploadDocumentSwitch" style="color: green">YES</span>
                            <span v-show="!uploadDocumentSwitch" style="color: red">NO</span>
                            {{uploadDocumentSwitch ? `| Allows receivers to upload output and supporting documents` : `| Don't allow receivers to upload output and supporting documents` }}
                          </span>
                        </template>
                        </v-switch>
                        <!-- <v-switch
                          v-model="commentAccessSwitch"
                          label="Allow view of comments"
                        
                        ></v-switch> -->
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>

              <v-container fluid v-show="text == 'Receivers'">
                <AssignReceiversModal
                  :showSelect="text"
                  :initiatorDueDate="datetime_due"
                />
              </v-container>

              <v-container fluid>
                <AssignDocuments :showSelect="text" @checkMainDocument="checkMainDocument"/>
              </v-container>
              <v-container fluid style="padding: 0px" v-show="text == 'Review'" >
                <AssignRoutePreview 
                :urgency="urgency"
                :subject="subject"
                :showSelect="text" 
                :datetime="datetime_due"
                :isSaving="isSaving"
                />
              </v-container>
              <v-container>
                <v-row>
                  <v-col cols="12" v-if="errorMessage">
                    <h3 class="text-center red--text">
                      {{ errorMessage }}
                    </h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions :class="text == 'Documents' ? 'mt-n15' : ''">
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                @click="backStep"
                :disabled="disableBack"
              >
                Back
              </v-btn>
              <v-btn
                v-show="text != 'Review'"
                color="primary"
                @click="continueStep"
                :disabled="disableContinue"
              >
                Continue
              </v-btn>
              <v-btn
                v-show="text == 'Review'"
                color="primary"
                @click="save()"
                :disabled="disableAdd"
              >
                Add
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import Swal from "sweetalert2";
  import AssignReceiversModal from "./AssignReceiversModal";
  import AssignDocuments from "./AssignDocuments";
  import AssignRoutePreview from "./AssignRoutePreview.vue"
  import moment from "moment";
  import LoadingOverlay from "./common/LoadingOverlay.vue";

  export default {
    name: "RecordCategoryModal",
    props: {
      dialog: Boolean,
      fromDocument: Boolean,
    },
    components: {
      AssignReceiversModal,
      AssignDocuments,
      LoadingOverlay,
      AssignRoutePreview
    },
    data() {
      return {
        loading: false,
        content: "Details",
        name: "",
        label: "",
        disableAdd: false,
        security_level: "",
        urgency: "",
        subject: "",
        datetime_due: moment(new Date())
          .add(3, "days")
          .toISOString()
          .substr(0, 10),
        errorMessage: null,
        security_level_items: ["Low", "Moderate", "High"],
        text: "Details",
        assigned_users: [],
        assigned_records: [],
        snackbar: this.fromDocument ? true : false,
        menu: false,
        dateSwitch: true,
        uploadDocumentSwitch: true,
        commentAccessSwitch: false,
        disableContinue: false,
        disableBack: true,
        isSaving: false,
      };
    },
    methods: {
      ...mapActions([
        "createRecordCategory",
        "getUnassignedUsers",
        "getAssignedUsers",
        "createRoute",
        "fetchAllSenders",
        "fetchDocumentCategories",
        "fetchUsersInOffice",
        "clearReceivers",
        "removeInitiatedDocuments",
      ]),
      checkMainDocument(body) {
        let hasMainDocument = false
        body.main.forEach(document => {
          if(document.isMainDocument)
            hasMainDocument = true
        })
        body.sub.forEach(document => {
          if(document.isMainDocument){
            hasMainDocument = true
          }
        })
        if(!hasMainDocument){
          this.disableAdd = true
        }else {
          this.disableAdd = false
        }
      },
      backStep(){
        if(this.text == "Receivers"){
          this.text = "Details"
          return true
        } else if(this.text == "Documents"){
          this.text = "Receivers"
          return true
        } else if(this.text == "Review"){
          this.text = "Documents"
          return true
        }
      },
      continueStep() {
        if(this.text == "Details"){
          this.text = "Receivers"
          return true
        } else if(this.text == "Receivers"){
          this.text = "Documents"
          return true
        } else if(this.text == "Documents"){
          this.text = "Review"
          this.disableContinue = true;
          return true
        }
      },
      close() {
        this.$emit("closeDialog", false);
        this.snackbar = false;
        // this.clearReceivers();
      },
      async save() {
        this.isSaving = true
        const body = {
          name: this.name,
          label: this.label,
          security_level: this.security_level,
          urgency: this.urgency,
          subject: this.subject,
          datetime_due: this.datetime_due,
          datetime_status: this.dateSwitch,
          uploadDocumentConfig: this.uploadDocumentSwitch,
          commentAccessConfig: this.commentAccessSwitch,
        };

        let actionCheck = false;

        // validate receivers
        this.addedReceivers.forEach((element) => {
          if (!element.action) actionCheck = true;
        });

        if (actionCheck) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Please make sure all receivers have actions",
          });
        } else {
          
          this.loading = true;
          const create = await this.createRoute(body);
          if (create.error) {
            this.loading = false
            if (create.status == 400) this.errorMessage = create.message;
            else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Internal Server Error",
              });
            }
          } else if (create) {
            
            // this.clearReceivers()
            this.loading = false
            let documents = create;
            this.removeInitiatedDocuments(documents);
            this.showSuccess = true;
            this.name = "";
            this.label = "";
            this.security_level = "";
            this.urgency = "";
            this.subject = "";
            this.datetime_due = moment(new Date())
              .add(3, "days")
              .toISOString()
              .substr(0, 10),
            this.errorMessage = null;
            this.dateSwitch = true;
            this.$emit("closeDialog", true);
          }
        }
      },
      toggleButton() {
        this.errorMessage = null;
      },
    },
    computed: {
      ...mapGetters(["addedDocuments", "addedReceivers"]),
      computedDateTimeDue() {
        return moment(new Date(this.datetime_due)).format("dddd, MMMM DD YYYY");
      },
    },
    created() {
      // this.clearReceivers();
      this.fetchAllSenders();
      this.fetchDocumentCategories();
      // this.fetchUsersInOffice();
    },
    watch: {
      urgency: function() {
        console.log(this.urgency)
        console.log(this.datetime_due)
      },
      text: function() {
        if(this.text == "Details" || this.text == "Receivers" || this.text == "Documents")
          this.disableContinue = false
        if(this.text == "Details")
          this.disableBack = true
        if(this.text == "Receivers" || this.text == "Documents" || this.text == "Review")
          this.disableBack = false
        if(this.text == "Review")
          this.disableContinue = true;
      },
      addedDocuments: function() {
        if (this.addedDocuments.length > 0 && this.addedDocuments.length < 2) {
          this.subject = this.addedDocuments[0].subject;
        }
      },
      dialog: function() {
        if (this.fromDocument) {
          this.snackbar = true;

          if (this.addedDocuments.length > 0) {
            this.subject = this.addedDocuments[0].subject;
          }
        }

        // let d = new Date();

        // let year = d.getFullYear();
        // let day = d.getDate();
        // let month = d.getMonth() + 1;
        // month = month < 10 ? `0${month}` : month;

        // let today = `${year}-${month}-${day}`;
        // let time = "23:59";

        // let formatDate = moment(today + " " + time);
        // let defaultDate = moment(formatDate).add(3, "days");

        // this.datetime_due = moment(new Date(defaultDate)).format("MMMM DD, YYYY");
      },
    },
  };
</script>

<style scoped></style>
